var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _line, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMapsMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "maps-mark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M.75,6.26a1.5,1.5,0,0,1,.943-1.393L7.074,2.715a3,3,0,0,1,2.333.044l4.487,1.994a3,3,0,0,0,2.244.078l5.1-1.855a1.5,1.5,0,0,1,2.013,1.41V17.694a1.5,1.5,0,0,1-.987,1.409l-6.125,2.228a3,3,0,0,1-2.244-.078L9.407,19.259a3,3,0,0,0-2.333-.044L2.807,20.922A1.5,1.5,0,0,1,.75,19.529Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.375,11.244a.375.375,0,0,1,.375.375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12,11.619a.375.375,0,0,1,.375-.375"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.375,11.994A.375.375,0,0,1,12,11.619"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.75,11.619a.375.375,0,0,1-.375.375"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.375,13.75a.375.375,0,0,1,.375.375"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9,14.125a.375.375,0,0,1,.375-.375"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.375,14.5A.375.375,0,0,1,9,14.125"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M9.75,14.125a.375.375,0,0,1-.375.375"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.375,11.5a.375.375,0,0,1,.375.375"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6,11.875a.375.375,0,0,1,.375-.375"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.375,12.25A.375.375,0,0,1,6,11.875"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.75,11.875a.375.375,0,0,1-.375.375"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.125,14.5a.375.375,0,0,1,.375.375"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M3.75,14.875a.375.375,0,0,1,.375-.375"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.125,15.25a.375.375,0,0,1-.375-.375"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.5,14.875a.375.375,0,0,1-.375.375"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.75,
    y1: 8.244,
    x2: 20.25,
    y2: 12.744
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "a",
    x1: 15.75,
    y1: 12.744,
    x2: 20.25,
    y2: 8.244
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapsMark);
export default __webpack_public_path__ + "static/media/maps-mark.8c8effaa11233dd5eafccc9c3039e5a0.svg";
export { ForwardRef as ReactComponent };